// TODO: This javascript must be cleaned !
// The function formatText() is styling the text of the features (bold + change content) because
// we are using the same Prismic documents than the mobile apps teams so we can't style everything
// as we want and need custom js for it.

import formatText from '@src/ab_tasty_customs/pricing/textFormatterI18n';
// format the text by default in in every languages on pricing page.
if (
  window.location.pathname.indexOf('/pricing') >= 0
) {
  document.addEventListener('DOMContentLoaded', function (_event) {
    formatText();
  });
  // select type of card
  const cards = document.querySelectorAll('.feature_definition .card');
  const lang = document.querySelector('html').lang;
  const cardNotifTextTranslated = () => {
    if (lang === 'fr') return ['Carte One (incluse)', 'Carte Plus (+6€/mois)', 'Carte X (+20€/mois)'];
    if (lang === 'en') return ['One Card (Included)', 'Plus Card (+€6 per month)', 'X Card (+€20 per month)'];
    if (lang === 'de') return ['One Card (Kostenlos)', 'Plus Card (+6 € pro Monat)', 'X Card (+20 € pro Monat)'];
    if (lang === 'es') return ['Tarjeta One (Gratis)', 'Tarjeta Plus (+6 € al mes)', 'Tarjeta X (+20 € al mes)'];
    if (lang === 'it') return ['Carta One (Gratis)', 'Carta Plus (+6€ al mese)', 'Carta X (+20€ al mese)'];
    if (lang === 'en-de') return ['One Card (Included)', 'Plus Card (+€6 per month)', 'X Card (+€20 per month)'];
  };
  const cardNotifText = cardNotifTextTranslated();
  const cardNotifImages = [
    {
      image: 'https://qonto-assets.s3.eu-central-1.amazonaws.com/pricing/fr-comparator-table-onecard.png',
      text: cardNotifText[0]
    },
    {
      image: 'https://qonto-assets.s3.eu-central-1.amazonaws.com/pricing/fr-comparator-table-pluscard.png',
      text: cardNotifText[1]
    },
    {
      image: 'https://qonto-assets.s3.eu-central-1.amazonaws.com/pricing/fr-comparator-table-xcard.png',
      text: cardNotifText[2]
    }
  ];

  const initializeCard = () => {
    const allImagesCard = document.querySelectorAll('.compare-plans-v3-section .feature_values--image img');
    const allTextsCard = document.querySelectorAll('.compare-plans-v3-section .feature_values--text');
    allImagesCard.forEach((image) => {
      image.srcset = cardNotifImages[0].image;
      image.src = cardNotifImages[0].image;
    });
    allTextsCard.forEach((text) => {
      text.textContent = cardNotifImages[0].text;
    });
  };
  initializeCard();

  cards.forEach(card => {
    card.addEventListener('click', () => {
      const altPageCards = document.querySelectorAll('.alt-page:not(.hidden) .feature_definition .card');
      const cardsNotifText = document.querySelectorAll('.alt-page:not(.hidden) .compare-plans-v3-section .feature_values--text');
      const cardsNotif = document.querySelectorAll('.alt-page:not(.hidden) .compare-plans-v3-section .feature_values--image img');

      altPageCards.forEach(card => card.classList.remove('border-2'));
      card.classList.add('border-2');
      cardsNotif.forEach((image, index) => {
        image.srcset = cardNotifImages[card.dataset.type].image;
        cardsNotifText[index].textContent = cardNotifImages[card.dataset.type].text;
      });
    });
  });

  // select plan in table
  const cardsPlan = [
    { name: 'solo', numbers: ['x1', 'x1', 'x1'] },
    { name: 'team', numbers: ['x2', 'x5', 'x15'] },
    { name: 'creation', numbers: ['x1', 'x1', 'x2'] }
  ];

  const handleChangePlan = value => {
    const stickyHeader = document.querySelector('.alt-page:not(.hidden) .compare-plans-v3-section .sticky-header-desktop');
    const tags = document.querySelectorAll('.compare-plans-v3-section .feature_values--image--tag');
    const plan = cardsPlan.find(plan => plan.name === value) || cardsPlan[0];

    stickyHeader.classList.add('hidden');

    if (tags) {
      for (let i = 0; i < tags.length; i += 3) {
        const tagsPart = Array.from(tags).slice(i, i + 3);
        tagsPart.forEach((tag, index) => {
          tag.textContent = plan.numbers[index];
        });
      }
    }
  };

  const url = new URL(window.location.href);
  const selectedPlan = url.searchParams.get('select-toggle');
  if (selectedPlan) {
    handleChangePlan(selectedPlan);
  }

  const toggleItems = document.querySelectorAll('.toggle > a');
  toggleItems.forEach(toggleItem => {
    toggleItem.addEventListener('click', () => {
      setTimeout(() => {
        const value = toggleItem.dataset.paramsSlug;
        handleChangePlan(value);
      }, 300);
    });
  });
}
